// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1412":"3c6911ccda90d32c","2924":"f829245bfa273b1e","6171":"fed1e2db2f70d0bf","6602":"25d182c11830e52d","7178":"3ab9aecf14180b62"}[chunkId] + ".js";
};